export enum LocalStorageKeys {
  USER_ID = 'userId',
  INDUSTRY = 'industry',
}
